"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _createStyled = require("../../../utils/createStyled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _label = _interopRequireDefault(require("../style/label"));

var Label = function Label(_ref) {
  var label = _ref.label,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["label"]);
  return label ? _react["default"].createElement(_createStyled.Styled.Label, {
    styles: (0, _label["default"])(rest)
  }, label) : null;
};

Label.propTypes = {
  label: _propTypes["default"].string
};
var _default = Label;
exports["default"] = _default;